//initiate
$(document).on('ready',function () {

    Response.create({
        prop: "width",
        prefix: "min-width- r src",
        breakpoints: [768, 0],
        lazy: true
    });

    if (Response.band(768)) {
        $('.nav-wrap').css('display', 'block');
    } else {
        $('.nav-wrap').css('display', 'none');
    }

    // Main navigation
    setMobileMenu();

    //matchHeight
    if ($('.mh').length) {
        $(".mh > *").matchHeight();
        $(".mh-2 > *").matchHeight();
    }
    if ($('.mh-item').length) {
        $(".mh-item").matchHeight();
    }

    if ($('.validate').length) {
        if (!Modernizr.touch) {
            $('.validate').validationEngine();
        } else {
            $('.validate').validationEngine({scroll: false});
        }
    }

    //set visuals
    setBlockVisuals();


    $('#message').click(function () {
        $('#message').hide();
    });

    //read more
    $('.read-more').click(function () {
        if ($(this).attr('rel') != 'showExtra') {
            extraTxt = $(this).parent('p').parent('div').find('.leesmeer');
            extraTxt.show('fast');
            extraTxt.css('height', 'auto');
            $(this).hide();
        } else {
            extraTxt = $(this).parent('p').parent('div').find('.leesmeer');
            extraTxt.hide('fast');
            extraTxt.css('height', '0');
            $(this).hide();
        }
    });

    if ($('.hero').length) {
        $('.slick').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 6000,
            pauseOnHover: true,
            fade: true,
            vertical: false,
            focusOnSelect: true,
            adaptiveHeight: true,
            infinite: true,
            mobileFirst: true
        });
    }

    if ($('.slick-center').length) {
        $('.slick').slick({
            slide: ".slick-slide",
            draggable: true,
            accessibility: false,
            centerMode: true,
            variableWidth: true,
            slidesToShow: 1,
            dots: true,
            swipeToSlide: true,
            infinite: true,
            mobileFirst: true,
            prevArrow: '<div class="prev"><i class="fa fa-chevron-left"></i></div>',
            nextArrow: '<div class="next"><i class="fa fa-chevron-right"></i></div>',
            customPaging: function (slider, i) {
                var slideNumber = (i + 1),
                    totalSlides = slider.slideCount;
                return '<a class="custom-dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">' + slideNumber + '/' + totalSlides + '</span></a>';
            }
        });
    }

    setScrollTo();

    // fancyBox
    if( $("[data-fancybox]").length ){
        $("[data-fancybox]").fancybox({
            // Options will go here
        });
    }

    if ($('.description-list').length) {
        $('.description-title').click(function () {
            $(".description-list li").removeClass("active");
            $(this).parent("li").toggleClass("active");
        });
    }

    /*
     * Datepicker
     */

    if( $(".datepicker-ui").length ) {

        $.datepicker._defaults.onAfterUpdate = null;
        var datepicker__updateDatepicker = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function (inst) {
            datepicker__updateDatepicker.call(this, inst);
            var onAfterUpdate = this._get(inst, 'onAfterUpdate');
            if (onAfterUpdate)
                onAfterUpdate.apply((inst.input ? inst.input[0] : null),
                    [(inst.input ? inst.input.val() : ''), inst]);
        }

        $(function () {
            var cur = -1, prv = -1;
            var dateToday = new Date();

            $('#checkin')
                .datepicker({
                    //numberOfMonths: 3,
                    minDate: dateToday,
                    beforeShowDay: function (date) {
                        var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
                        return [CHECKOUT.indexOf(string) == -1];
                    },
                    onSelect: function() {
                        var date = $(this).datepicker('getDate');

                        // Remove CHECKOUT date when CHECKIN is later then CHECKOUT
                        if ($('#checkout').datepicker('getDate')) {
                            var date2 = $('#checkout').datepicker('getDate');
                            if ( Date.parse(date) >= Date.parse(date2) ) {
                                $('#checkout').datepicker('setDate', null);
                            }
                        }

                        // Set mindate of CHECKOUT datepicker when selecting CHECKIN date
                        if (date) {
                            date.setDate(date.getDate() + 1);
                            $('#checkout').datepicker("option", "minDate", date)
                        }
                    }
                });


            $('#checkout')
                .datepicker({
                    //numberOfMonths: 3,
                    minDate: dateToday,
                    beforeShowDay: function (date) {
                        var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
                        return [CHECKIN.indexOf(string) == -1];
                    }
                });
        });

    }

});

function setScrollTo() {
    //set links
    var IDlinks = $('a.scroll-to');
    IDlinks.click(function (e) {
        scrollToDiv($(this).attr('href'));
        e.preventDefault();
    });

    //check hash in url
    if (window.location.hash) {
        var whash = window.location.hash;
        scrollToDiv(whash);
    }

}

function scrollToDiv(id) {
    if ($('#mobilemenubtn').css('display') == 'none') {
        var hh = 103;
    } else {
        var hh = 0;
    }
    var offset = $(id).offset().top - hh;

    $('html, body').animate({
        scrollTop: offset
    }, 800);
}

var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

//validator e-mail
function isValidEmailAddress(emailAddress) {
    if (emailAddress == '' || !emailAddress) {
        return false;
    }
    var pattern = new RegExp(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/);
    return pattern.test(emailAddress);
}

function setMobileMenu() {

    $('.main-nav .hamburger-menu').click(function (e) {
        e.preventDefault();
        $(this).next('.nav-wrap').slideToggle('fast');
    });

    Response.crossover('width', function () {
        if (Response.band(768)) {
            $('.nav-wrap').css('display', 'block');
        } else {
            $('.nav-wrap').css('display', 'none');
        }
    });

}

//set visuals (image to background)
function setBlockVisuals(){
    var visuals = $('.block-visual');
    if(visuals.length){
        visuals.each(function(){
            var img = $(this).find('img');
            var src = img.attr('src');
            $(this).css('background-image','url('+src+')');
            img.hide();
        })
    }
}